import React from 'react'
import { ThemeProvider } from 'styled-components'
import { Theme } from '../WebsiteThemeElements'

import { 
    Button, 
    BannerContainer, 
    BannerH2, 
    AppLogo, 
    AppButtons,
    Img 
} from './AppBannerElements'



const AppBanner = ({appName, logo, playStoreLink, appStoreLink}) => {
   
    return (
        <>
        <ThemeProvider theme={Theme({})}>
        <BannerContainer>
            <BannerH2>
            <BannerH2>
            <img height={40} width={40} style={ {borderRadius: '50px', marginRight: '1%'}} src={"../../images/xumm_app_logo.png"} alt={"appName"}/>

            </BannerH2>
                Download the {appName} Wallet to Register

            </BannerH2>
           
                <AppButtons>
                    <Button href={playStoreLink}>
                        <img height={150} width={150} src={"../../google_play_badge.png"} alt='Google Play'/>
                    </Button>
                    <Button href={appStoreLink}>
                        <img height={150} width={150} src={"../../app_store_badge.png"} alt='App Store'/>
                    </Button>
                </AppButtons>
            
        </BannerContainer>
        </ThemeProvider>
        </>
    )
}

export default AppBanner